import { useFetch } from 'app/queryProvider';
import { IReportsResponse } from '../types/Reports';
import { buildHistoryQueryString } from '../utils/historyQuery';

export const useTelemonitoringReports = (
  pathwayId: string,
  createdAtRanges?: string[] | null,
) => {
  const queryString = buildHistoryQueryString({
    filter: { status: 'sent' },
    createdAtRanges,
  });

  const { data, isLoading, isRefetching, refetch } = useFetch<IReportsResponse>({
    url: `?${queryString}`,
    queryKey: [['telemonitoring-reports', 'history', pathwayId, queryString]],
    resource: { name: 'telemonitoring-reports' },
    options: { enabled: !!pathwayId },
  });

  return {
    reports: data?.results ?? [],
    isLoading,
    isRefetching,
    refetch,
  };
};
